import { useLocation } from 'react-router-dom';
import { resolveBreadcrumbTrail } from '../lib/parentMap';
import { parentMapTLA } from '../config/parentMap.tla';

// Derives the breadcrumb trail for the current route from the product parent-map.
export function useBreadcrumbs() {
  const { pathname } = useLocation();
  return resolveBreadcrumbTrail(parentMapTLA, pathname);
}
